import { toast } from "react-toastify";

let id: any;

export const showLoadingToast = (message: string) => {
  id = toast.loading(message);
};

export const showSuccessToast = (message: string) => {
  if (id) {
    toast.update(id, {
      render: message,
      type: "success",
      isLoading: false,
      autoClose: 1500,
    });
    id = null;
  } else {
    toast.success(message, {
      autoClose: 1500,
    });
  }
};

export const showErrorToast = (message: string) => {
  if (id) {
    toast.update(id, {
      render: message,
      type: "error",
      isLoading: false,
      autoClose: 2000,
    });
    id = null;
  } else {
    toast.error(message, {
      autoClose: 1500,
    });
  }
};

export const showInfoToast = (message: string) => {
  if (id) {
    toast.update(id, {
      render: message,
      type: "info",
      isLoading: false,
      autoClose: 1500,
    });
    id = null;
  } else {
    toast.info(message, {
      autoClose: 1500,
    });
  }
};

export const showWarnToast = (message: string) => {
  if (id) {
    toast.update(id, {
      render: message,
      type: "warning",
      isLoading: false,
      autoClose: 1500,
    });
    id = null;
  } else {
    toast.warn(message, {
      autoClose: 1500,
    });
  }
};

export const handleAPIErrorToast = (error: any) => {
  if (error && error.response.status === 404) {
    return showErrorToast("Not Found");
  }
  if (error && error.response.status === 401) {
    return showErrorToast("Unauthorized");
  }
  if (error && error.response.status === 403) {
    return showErrorToast("Forbidden");
  }
  return showErrorToast(error?.response?.data?.message || error.message);
};
